import { Fragment } from 'react'
import Route from './routes/route'

import './styles/style.css'

const App = () => {
  return (
    <Fragment>
        <Route />
    </Fragment>
  )
}

export default App